import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input, InputNumber, Radio, message } from 'antd'
import { SelectF } from '@/i2antdV5'
import { fetchTuinaMemberList } from '@/redux/tuina/memberListSlice'
import { fetchTuinaProjectList } from '@/redux/tuina/projectListSlice'
import { TUINA_PAY_METHOD_OPTIONS } from '@/views/tuina/options'

const FormItem = Form.Item

class PurchaseOrderForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    record: PropTypes.object,
    memberId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    memberList: PropTypes.object,
    projectList: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    this.fetchMembers()
    this.fetchProjects()
    this.syncRecord()
  }

  componentDidUpdate (prevProps) {
    const prevId = prevProps.record && prevProps.record.id
    const nextId = this.props.record && this.props.record.id
    const prevStoreId = prevProps.storeId || (prevProps.record && prevProps.record.storeId)
    const nextStoreId = this.props.storeId || (this.props.record && this.props.record.storeId)
    if (prevId !== nextId || prevStoreId !== nextStoreId) {
      this.fetchMembers()
      this.fetchProjects()
      this.syncRecord()
    }
    if (prevProps.memberId !== this.props.memberId) this.syncRecord()
  }

  fetchMembers = (phone) => {
    const { dispatch, record, memberId, storeId, projectList } = this.props
    if (memberId != null && memberId !== '') return
    const query = { pageNumber: 1, pageSize: 200 }
    const sid = storeId || (record && record.storeId) || projectList.query.storeId
    if (sid != null && sid !== '') query.storeId = sid
    if (phone) query.phone = phone
    dispatch(fetchTuinaMemberList({ query }))
  }

  handleMemberSearch = (input) => {
    if (this.memberSearchTimer) clearTimeout(this.memberSearchTimer)
    this.memberSearchTimer = setTimeout(() => {
      this.fetchMembers(String(input || '').trim())
    }, 300)
  }

  componentWillUnmount () {
    if (this.memberSearchTimer) clearTimeout(this.memberSearchTimer)
  }

  fetchProjects = () => {
    const { dispatch, record, storeId } = this.props
    if (record && record.id != null && record.id !== '') return
    const query = { pageNumber: 1, pageSize: 200, status: 'on_sale' }
    if (storeId != null && storeId !== '') query.storeId = storeId
    dispatch(fetchTuinaProjectList({ query }))
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载服务项目失败'))
  }

  syncRecord = () => {
    const { form, record, memberId } = this.props
    if (!form || !form.current) return
    form.current.setFieldsValue({
      projectId: record && record.id,
      memberId: memberId != null && memberId !== '' ? memberId : undefined,
      quantity: 1,
      payMethod: TUINA_PAY_METHOD_OPTIONS[0] && TUINA_PAY_METHOD_OPTIONS[0].id,
      remark: ''
    })
  }

  render () {
    const { form, record, memberId, memberList, projectList } = this.props
    const memberLocked = memberId != null && memberId !== ''
    const projectLocked = record && record.id != null && record.id !== ''
    const memberRows = Array.isArray(memberList.data.list) ? memberList.data.list : []
    const memberOptions = memberRows
      .filter((row) => row.status !== 'FROZEN')
      .map((row) => ({
        id: row.id,
        value: row.phone ? `${row.name} ${row.phone}` : row.name,
        phone: row.phone
      }))
    const projectRows = Array.isArray(projectList.data.list) ? projectList.data.list : []
    const projectOptions = projectLocked
      ? [{ id: record.id, value: record.name }]
      : projectRows.map((row) => ({
        id: row.id,
        value: row.name
      }))

    return (
      <Form ref={form} layout="vertical">
        <FormItem
          label="项目"
          name="projectId"
          rules={[{ required: true, message: '请选择项目' }]}
        >
          <SelectF
            options={projectOptions}
            modalProps={{
              size: 'large',
              disabled: projectLocked,
              allowClear: false,
              placeholder: '请选择项目',
              loading: !projectLocked && projectList.fetching,
              getPopupContainer: () => document.body,
              dropdownStyle: { zIndex: 1200 },
              style: { width: '100%' }
            }}
          />
        </FormItem>
        <FormItem
          label="会员"
          name="memberId"
          rules={[{ required: true, message: '请选择会员' }]}
        >
          <SelectF
            options={memberOptions}
            modalProps={{
              size: 'large',
              disabled: memberLocked,
              placeholder: '请选择会员',
              loading: memberList.fetching,
              onSearch: this.handleMemberSearch,
              getPopupContainer: () => document.body,
              dropdownStyle: { zIndex: 1200 },
              style: { width: '100%' }
            }}
          />
        </FormItem>
        <FormItem
          label="数量"
          name="quantity"
          rules={[{ required: true, message: '请填写数量' }]}
        >
          <InputNumber size="large" min={1} precision={0} style={{ width: '100%' }} />
        </FormItem>
        <FormItem
          label="支付方式"
          name="payMethod"
          rules={[{ required: true, message: '请选择支付方式' }]}
        >
          <Radio.Group size="large" optionType="button" buttonStyle="solid">
            {TUINA_PAY_METHOD_OPTIONS.map((item) => (
              <Radio.Button key={item.id} value={item.id}>{item.value}</Radio.Button>
            ))}
          </Radio.Group>
        </FormItem>
        <FormItem
          label="备注"
          name="remark"
        >
          <Input.TextArea
            rows={3}
            size="large"
            placeholder="选填"
            allowClear
            maxLength={512}
            showCount
          />
        </FormItem>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  memberList: state.tuina.memberList,
  projectList: state.tuina.projectList
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(PurchaseOrderForm)
